const inputLogin = {
  username: '用户名',
  password: '密码',
};

export default inputLogin;
